import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function ConclusionPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Conclusion</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              Sustainability in microalgal production systems depends on three
              critical factors: (i) efficient cultivation with a reduced
              ecological water footprint, (ii) economical harvesting, and (iii)
              appropriate downstream processes with a minimal environmental
              burden. Seawater usage for microalgae cultivation has been a
              better substitute for scarce freshwater resources and higher
              biodiesel yields [79] and has shown positive effects on
              sustainable cultivation. Moreover, there have been improvements in
              biodiesel yield of up to 4.17 &nbsp;10<sup>5</sup> ML/year [80]
              using saline water, apart from reducing the freshwater footprint.
              In conventional microalgae production systems, harvesting accounts
              for about 20&ndash;30 % of biomass production costs [81,82].
            </p>
            <p>
              The present work emphasizes the merits of attached diatom (with
              biofilm) cultivation using low-cost substrates such as gravel
              stones, producing ~ 5 times more biomass than suspended
              cultivation along with a considerable reduction in the harvesting
              costs, estimated as 20 INR per kg. This has been done through lab
              and field experimentation and is a first-of-its-kind study on
              diatoms, focusing on mitigation of the bottlenecks encountered in
              harvesting. The techno-economic analysis conducted to determine
              the possible monetary benefits in establishing an
              environment-friendly sustainable microalgal production system
              demonstrated significant economic benefits through biomass,
              biofuel, and other value-added products. In addition,
              environmental lifecycle assessment of biodiesel production through
              enzymatic transesterification using biocatalysts (lipase) showed
              potential to be an appropriate downstream process with minimal
              ecological burdens. Implementing such measures in future
              microalgal biofuel production systems would render substantial
              energy with cost reductions and remediation, leading to a holistic
              approach towards sustainable third-generation biofuel production.
            </p>
            <p>
              <strong>Funding</strong>
            </p>
            <p>
              <strong>&nbsp;</strong>The research was financially supported - i)
              ISRO &ndash; IISc space technology cell [ISTC/BES/TVR/389] and
              Gajanana and Madhavi Hegde [CES/TVR/GJH001] endowment for biofuel
              research.
            </p>

            <p>
              <strong>Acknowledgments</strong>
            </p>
            <p>
              The authors are grateful to (i) the NRDMS division, Ministry of
              Science and Technology, Government of India [CES/TVR/DST1045], and
              ii) the Indian Institute of Science for the infrastructure support
              for ecological research. We acknowledge the support of the
              Advanced Facility for Microscopy and Microanalysis for SEM imaging
              and Micro-Nano characterization Facility (MNCF). We thank
              Sreekanth Naik, Vishnu D Mukri, and Gayatri Naik for their
              assistance during the field data collection. We thank all
              stakeholders in the study region for actively participating in the
              scientific discussions and cooperation during field data
              compilation. We are grateful to the official languages section at
              IISc for the assistance in language editing.
            </p>

            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default ConclusionPage;
